export default __webpack_public_path__ + "static/case-2-hero-3a182553744f6e11151dab581f66f9b1.png";